module.exports = __webpack_public_path__ + "img/12.9dcb1371.png";